import React from 'react';
import './StoreUnavailable.scss';

interface StoreUnavailableProps {
  onReturn: () => void;
  temporary: boolean;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function StoreUnavailable({ temporary, onReturn }: StoreUnavailableProps) {
  return (
    <div className="login-loading-container">
      <div className="login-loading-content">
        <div className="login-loading-main-text">Sorry!</div>
        <div className="login-loading-sub-text">
          {
            temporary
              ?
              (
                <div className="sub-text-content">
                  The online store is temporarily not available in your country.
                </div>
              )
              :
              (
                <div className="sub-text-content">
                  At this time, the online store is not available in your country.
                </div>
              )
          }
          <div>Please check back soon!</div>
        </div>
      </div>
    </div>
  );
}

export default StoreUnavailable;
